// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .chart-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
  padding-top: 5px;
}
:host .section-item {
  width: 100%;
}
:host .field-block {
  width: 100%;
}
:host .field-block mat-select, :host .field-block input, :host .field-block span {
  width: calc(100% - 15px);
}
:host .field-text input {
  width: 70px;
}
:host .field-number {
  width: 60px;
}
:host .field-number input {
  width: inherit;
  text-align: center;
}
:host .field-number span {
  width: 65px;
  text-align: left;
}
:host .section-inline-margin-s {
  display: inline-block;
  width: 5px;
}
:host .section-inline-color {
  display: inline-block;
  width: 60px;
}
:host .section-inline-color input {
  width: 60px !important;
  text-align: center;
}
:host .section-inline-color span {
  width: 60px;
}
:host .section-inline-margin {
  display: inline-block;
  width: 12px;
}
:host .section-inline-margin2 {
  display: inline-block;
  width: 16px;
}
:host .section-newline {
  height: 8px;
  display: block;
}
:host ::ng-deep .slider-field mat-slider {
  background-color: var(--formSliderBackground);
  height: 30px;
  width: 100px;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
  min-width: 110px !important;
  width: 110px !important;
}
:host .events-section {
  display: contents;
}
:host .events-section .event-item {
  margin-top: 5px;
}
:host .events-section .event-type {
  width: 120px;
}
:host .events-section .event-action {
  width: 120px;
}
:host .events-section .event-remove {
  float: right;
}
:host .events-section .event-action-ext {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
:host .events-section .event-script {
  padding-left: 10px;
}
:host .events-section .event-script .script-selection {
  width: calc(100% - 15px);
}
:host .events-section .event-script .event-script-param {
  width: 120px;
}
:host .events-section .event-script .event-script-value {
  width: calc(100% - 120px);
}
:host .events-section .event-script .event-script-tag {
  width: calc(100% - 125px);
}
:host .events-toolbox {
  display: block;
  width: 100%;
}
:host .events-toolbox button {
  margin-left: 10px;
}
:host .section-item-block mat-select, :host input {
  width: calc(100% - 15px);
}

::ng-deep .chart-filter-option {
  line-height: 28px !important;
  height: 28px !important;
}
::ng-deep .chart-filter-option span {
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-chart/chart-property/chart-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-chart/chart-property/chart-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;ACAR;ADGI;EACI,WAAA;ACDR;ADII;EACI,WAAA;ACFR;ADGQ;EACI,wBAAA;ACDZ;ADKI;EACI,WAAA;ACHR;ADMI;EACI,WAAA;ACJR;ADOI;EACI,cAAA;EACA,kBAAA;ACLR;ADQI;EACI,WAAA;EACA,gBAAA;ACNR;ADSI;EACI,qBAAA;EACA,UAAA;ACPR;ADUI;EACI,qBAAA;EACA,WAAA;ACRR;ADWI;EACI,sBAAA;EACA,kBAAA;ACTR;ADYI;EACI,WAAA;ACVR;ADaI;EACI,qBAAA;EACA,WAAA;ACXR;ADcI;EACI,qBAAA;EACA,WAAA;ACZR;ADeI;EACI,WAAA;EACA,cAAA;ACbR;ADgBI;EACI,6CAAA;EACA,YAAA;EACA,YAAA;ACdR;ADiBI;EACI,uBAAA;EACA,2BAAA;EACA,uBAAA;ACfR;ADkBI;EACI,iBAAA;AChBR;ADkBQ;EACI,eAAA;AChBZ;ADkBQ;EACI,YAAA;AChBZ;ADkBQ;EACI,YAAA;AChBZ;ADkBQ;EACI,YAAA;AChBZ;ADkBQ;EACI,oBAAA;EACA,2CAAA;AChBZ;ADkBQ;EACI,kBAAA;AChBZ;ADiBY;EACI,wBAAA;ACfhB;ADiBY;EACI,YAAA;ACfhB;ADiBY;EACI,yBAAA;ACfhB;ADiBY;EACI,yBAAA;ACfhB;ADmBI;EACI,cAAA;EACA,WAAA;ACjBR;ADmBQ;EACI,iBAAA;ACjBZ;ADqBI;EACI,wBAAA;ACnBR;;ADuBA;EAEI,4BAAA;EACA,uBAAA;ACrBJ;ADuBI;EACI,eAAA;ACrBR","sourcesContent":[":host {\n    .chart-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n        padding-top: 5px;\n    }\n\n    .section-item {\n        width: 100%;\n    }\n\n    .field-block {\n        width: 100%;\n        mat-select, input, span {\n            width:calc(100% - 15px);\n        }\n    }\n\n    .field-text input {\n        width: 70px;\n    }\n\n    .field-number {\n        width: 60px;\n    }\n\n    .field-number input {\n        width: inherit;\n        text-align: center;\n    }\n\n    .field-number span {\n        width: 65px;\n        text-align: left;\n    }\n\n    .section-inline-margin-s {\n        display: inline-block;\n        width: 5px;\n    }\n\n    .section-inline-color {\n        display: inline-block;\n        width: 60px;\n    }\n\n    .section-inline-color input {\n        width: 60px !important;\n        text-align: center;\n    }\n\n    .section-inline-color span {\n        width: 60px;\n    }\n\n    .section-inline-margin {\n        display: inline-block;\n        width: 12px;\n    }\n\n    .section-inline-margin2 {\n        display: inline-block;\n        width: 16px;\n    }\n\n    .section-newline {\n        height: 8px;\n        display: block;\n    }\n\n    ::ng-deep .slider-field mat-slider {\n        background-color: var(--formSliderBackground);\n        height: 30px;\n        width: 100px;\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n        min-width: 110px !important;\n        width: 110px !important;\n    }\n\n    .events-section {\n        display: contents;\n\n        .event-item {\n            margin-top: 5px;\n        }\n        .event-type {\n            width: 120px;\n        }\n        .event-action {\n            width: 120px;\n        }\n        .event-remove {\n            float: right;\n        }\n        .event-action-ext {\n            padding-bottom: 10px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        }\n        .event-script {\n            padding-left: 10px;\n            .script-selection {\n                width: calc(100% - 15px);\n            }\n            .event-script-param {\n                width: 120px;\n            }\n            .event-script-value {\n                width: calc(100% - 120px);\n            }\n            .event-script-tag {\n                width: calc(100% - 125px);\n            }\n        }\n    }\n    .events-toolbox {\n        display: block;\n        width: 100%;\n\n        button {\n            margin-left: 10px;\n        }\n    }\n\n    .section-item-block mat-select, input {\n        width:calc(100% - 15px);\n    }\n}\n\n::ng-deep .chart-filter-option  {\n\n    line-height: 28px !important;\n    height: 28px !important;\n\n    span {\n        font-size: 13px;\n    }\n}",":host .chart-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n  padding-top: 5px;\n}\n:host .section-item {\n  width: 100%;\n}\n:host .field-block {\n  width: 100%;\n}\n:host .field-block mat-select, :host .field-block input, :host .field-block span {\n  width: calc(100% - 15px);\n}\n:host .field-text input {\n  width: 70px;\n}\n:host .field-number {\n  width: 60px;\n}\n:host .field-number input {\n  width: inherit;\n  text-align: center;\n}\n:host .field-number span {\n  width: 65px;\n  text-align: left;\n}\n:host .section-inline-margin-s {\n  display: inline-block;\n  width: 5px;\n}\n:host .section-inline-color {\n  display: inline-block;\n  width: 60px;\n}\n:host .section-inline-color input {\n  width: 60px !important;\n  text-align: center;\n}\n:host .section-inline-color span {\n  width: 60px;\n}\n:host .section-inline-margin {\n  display: inline-block;\n  width: 12px;\n}\n:host .section-inline-margin2 {\n  display: inline-block;\n  width: 16px;\n}\n:host .section-newline {\n  height: 8px;\n  display: block;\n}\n:host ::ng-deep .slider-field mat-slider {\n  background-color: var(--formSliderBackground);\n  height: 30px;\n  width: 100px;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n  min-width: 110px !important;\n  width: 110px !important;\n}\n:host .events-section {\n  display: contents;\n}\n:host .events-section .event-item {\n  margin-top: 5px;\n}\n:host .events-section .event-type {\n  width: 120px;\n}\n:host .events-section .event-action {\n  width: 120px;\n}\n:host .events-section .event-remove {\n  float: right;\n}\n:host .events-section .event-action-ext {\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n:host .events-section .event-script {\n  padding-left: 10px;\n}\n:host .events-section .event-script .script-selection {\n  width: calc(100% - 15px);\n}\n:host .events-section .event-script .event-script-param {\n  width: 120px;\n}\n:host .events-section .event-script .event-script-value {\n  width: calc(100% - 120px);\n}\n:host .events-section .event-script .event-script-tag {\n  width: calc(100% - 125px);\n}\n:host .events-toolbox {\n  display: block;\n  width: 100%;\n}\n:host .events-toolbox button {\n  margin-left: 10px;\n}\n:host .section-item-block mat-select, :host input {\n  width: calc(100% - 15px);\n}\n\n::ng-deep .chart-filter-option {\n  line-height: 28px !important;\n  height: 28px !important;\n}\n::ng-deep .chart-filter-option span {\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
